<template>
    <div class="subject-page">
        <div class="tit">伤寒论全文阅读及解析</div>
        <div class="page-cont">
            <ul class="tab-nav">
                <li :class="navIndex==item.type?'active':''" v-for="(item,index) in tabNav" :key="index" @click="tab_click(item)">{{ item.val }}</li>
            </ul>
            <div class="cont">
                <originalRead v-show="navIndex==1"></originalRead>
                <articleSearch v-show='navIndex==2'></articleSearch>
                <learn v-show='navIndex==3'></learn>
            </div>
        </div>
            
    </div>
</template>

<script>
//原文阅读
import originalRead from './literature/read_original.vue'
//索引查询
import articleSearch from './literature/article_search.vue'
//索引查询
import learn from './literature/learn.vue'
export default {
    components: { 
        originalRead,
        articleSearch,
        learn,
    },
    data() {
        return {
            navIndex:1,
            tabNav:[
                {
                    val:'原文阅读', type:1,
                },
                {
                    val:'索引查询', type:2,
                },
                {
                    val:'在线学习', type:3,
                }
            ]
        }
    },
    watch: {},
    mounted() {
        
    },
    methods: {
        tab_click(item){
            this.navIndex=item.type;
        }
    }
}
</script>
<style lang='less' scoped>
.subject-page{
    width: 1200px;
    margin: 40px auto;
    .tit{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .page-cont{
        // border:1px solid #386DE8;
        border-radius: 8px;
        box-shadow: 0px 3px 12px 0px #d3d8dc; 
    }
    .tab-nav{
        display: flex;
        justify-content: space-between;
        line-height: 44px; 
        // border-bottom:2px solid #F1F5FE;
        li{
            border-radius: 8px 8px 0 0;
            width: 396px;
            text-align: center;
            background:#F1F5FE;
            font-weight: bold;
            font-size: 16px;
            cursor: pointer;
            &:hover,&.active{

                background:#386DE8;
                color: #fff;
            }
        }
    }
    .cont{
        padding:20px;
    }

}
</style>